import { FC } from 'react';
import { Badge, BadgeProps, Button, ButtonProps, List, ListItem, MenuButton } from '@silverfort/sf-components';
import { FeatureLock, LockedFeatureDisplayConfig } from '../../../components/common/LockedFeatures';

interface InsightItemProps {
    title: string;
    description?: string;
    badgeProps?: BadgeProps;
    buttonProps: ButtonProps;
    buttonLockFeatureDisplayConfig?: LockedFeatureDisplayConfig;
    menuItems?: { id: string; label: string; onClick: () => void }[];
}

const InsightItem: FC<InsightItemProps> = ({
    title,
    description,
    badgeProps,
    buttonProps,
    buttonLockFeatureDisplayConfig = { enabled: true },
    menuItems = []
}) => {
    const getTopContainerFlexJustifyClassName = () => {
        if (!badgeProps) {
            return 'justify-end';
        }
        return 'justify-between';
    };

    return (
        <div className="group p-4 rounded-[8px] transition-colors bg-sf-gray-0 hover:bg-[#F5FAFF] flex flex-col gap-3">
            <div className={`flex ${getTopContainerFlexJustifyClassName()}`}>
                {badgeProps && <Badge {...badgeProps} />}
                {menuItems.length && (
                    <div className="hidden group-hover:block">
                        <MenuButton
                            openByDefault={false}
                            className="buttom-1 left-[-176px]"
                            content={
                                <List className="[&]:p-0 w-[184px] min-w-[184px]">
                                    {menuItems.map((item) => (
                                        <ListItem key={item.id} title={item.label} onClick={item.onClick} />
                                    ))}
                                </List>
                            }
                        />
                    </div>
                )}
            </div>
            <div className="w-full flex flex-col justify-between gap-3">
                <span className="font-sf-poppins text-13 font-medium leading-[15px] tracking-[0.203px]">{title}</span>
                {description && (
                    <span className="w-full font-sf text-12 text-sf-gray-500 leading-[16px]">{description}</span>
                )}
            </div>
            <FeatureLock displayOptions={buttonLockFeatureDisplayConfig}>
                <Button {...buttonProps} />
            </FeatureLock>
        </div>
    );
};

export default InsightItem;
